export const actionTypes = {
  UPDATED_EVENTS: 'UPDATED_EVENTS',
  NEW_CHECKIN: 'NEW_CHECKIN',
};
